import React, { useEffect, useMemo, useState } from "react"
import { authenticationService } from "services/authentication.service"
import { InformacionDetalleHistorialSolicitudPermisos, InformacionGeneralSolicitudes, TablaDetalleHistorialSolicitudPermisos, TiposPermiso } from "./TypesSolicitudesPermisos"
import { alertService } from "components/Varios/alert_service"
import Cargando from "components/Varios/Cargando"
import SolicitudPermisosContextProvider from "Context/SolicitudesPermisosContext"
import AlertNew, { TiposAlerta } from "components/Varios/AlertNew"
import { Button, Row, Col, Table, Container } from "reactstrap";
import { ObtenerDetalleHistorial, ObtenerInformacionGeneralSolicitudesPermisos } from "./FunctionSolicitudPermisos"
import CardHistorialSolicitudesPermisos from "./CardHistorialSolicitudesPermisos"
import DatosGenerales from "components/Prueba"
import CardSolicitudesPermisosLicencias from "./CardSolicitudesPermisosLicencias"
import { ResponseRequest } from 'components/Types/GeneralTypes'
import { ObtenerFechaFromIsoFormat, ParseHorasFormato } from 'functions/DatesFunctions'
import { DownloadDocument } from 'helpers/files'
import ModalConfirmacion from 'components/Varios/Modals/ModalConfirmacion'
import { string } from "prop-types"
import PdfSVG from "assets/icons/Permisos/PDF(azul).svg"

type StateSolicitudPermisos = {
    datosGenerales: InformacionGeneralSolicitudes,
    loadingDG: boolean,
    mensajeError: string,
    idRegimenLaboral: number[],
    fechaControlHorario: Date,
    puedeSolicitarPorHorario: boolean
}

type StateModalHistoricoDetalle = {
    loadingInformacion: boolean,
    tabladetalle: TablaDetalleHistorialSolicitudPermisos[] | undefined,
    anio: number,
}



export default function  SolicitudPermisos()
{
    const defaultState: StateSolicitudPermisos = {
        datosGenerales: {
            tiposSolicitudPermisos: [],
            tiposSolicitudLicencias: [],
            solicitudesPermisos: [], solicitudesLicencias: [],
            permisosIngresados: [], licenciasIngresadas: [], permisosCRN: [],
            diasPendientes: -1, anio: -1,
            feriados: [],
            esSubrogante: false,
            historial: [], 
            historialbyAnio: [],
            acuerdoMediosElectronicos: true,
            horaEntrada: "", horaSalida: "",
            esAprobador: false,
            horaInicioAlmuerzo: "",
            horaFinAlmuerzo: "",
            tiempoAlmuerzo: "",
            solicitudesVacaciones: [],
            ubicacionFisica: "",
            licenciasComisiones: [],
            empHorario: [],
            historialSolicitudesCH: [],
            solicitudesIngresadasCH: [],
            horaEntradaRegimen: "", horaSalidaRegimen: "", subtipoPermisos:[],
            horarioLaboralRegimen: {
                idRegimen: 0,
                horaEntrada: "",
                horaSalida: "",
                horaInicioReceso: "",
                horaFinReceso: ""
            },
            horarioLaboralPersona: [],
            jornadaLaboralPersona: [],
            tieneHorarioPermiso: false,
            tieneInfanteRegistrado: true,
            vacacionesIngresadas: [],
            estadoCivil: "",
            identificacionConyuge: "",
            tipoEventoMatrimonio: "",
            modalidadLicenciaMatrimonio: "",
            tipoIdentificacion: "",
            Conyuge: "",
            idRegimenLaboralS: 0,
            listadoHorarios: [],
            licenciaMaternidad: [],
            fechaFinContrato: "",
        },
        loadingDG: false,
        mensajeError: "",
        idRegimenLaboral: [],
        fechaControlHorario: new Date(),
        puedeSolicitarPorHorario: false,
        
    }

    const defaultStateModalHistoricoDetalle: StateModalHistoricoDetalle = {
        loadingInformacion: false,
        tabladetalle: undefined,
        anio: -1,
    }

    const [stateSolicitudPermisos, setstateSolicitudPermisos] = useState<StateSolicitudPermisos>(defaultState)
    const [stateModalHistoricoDetalle, setstateModalHistoricoDetalle] = useState<StateModalHistoricoDetalle>(defaultStateModalHistoricoDetalle)

    function HandleErrorInformacionGeneral(message?: string) {
        const mensaje = message ?? "Ha ocurrido un error al intentar obtener informacion de sus solicitudes"
        alertService.error(mensaje)
    }

    async function ObtenerDatosGenerales() {
        setstateSolicitudPermisos({ ...stateSolicitudPermisos, loadingDG: true })
        const respuesta = await ObtenerInformacionGeneralSolicitudesPermisos(HandleErrorInformacionGeneral)
        const listaRegimenServidor: number[] = authenticationService.currentUserValue.regimen_usuario;
        if (respuesta.status === 200) {
            setstateSolicitudPermisos({ ...defaultState, datosGenerales: respuesta.dataResponse, loadingDG: false, idRegimenLaboral: listaRegimenServidor })
        }
        else {
            setstateSolicitudPermisos({ ...defaultState, loadingDG: false, mensajeError: respuesta.errorMessage ?? "" })
        }

    }

    useEffect(() => {
        window.location.href = "https://th.espol.edu.ec/";
        //ObtenerDatosGenerales();
    }, [])

    

    function escogerIndice(indihist: number, indiReferencia: number) {
        if (indihist < indiReferencia) {
            return { indiceColor: indihist, indiReferencia }
        }
        indiReferencia = indiReferencia + 5 === indihist ? indihist : indiReferencia;
        if (indiReferencia === indihist) {
            return { indiceColor: 4, indiReferencia }
        }
        var indiceColor = indihist;
        if (indiceColor > indiReferencia) {
            indiceColor = indiceColor - indiReferencia - 1
        }


        return { indiceColor, indiReferencia };

    }

    async function VerDetalleHistorico(anioDeseado: number) {
        setstateModalHistoricoDetalle({ ...stateModalHistoricoDetalle, loadingInformacion: true, anio: anioDeseado })
        const respuestaRequestDetalle: ResponseRequest = await ObtenerDetalleHistorial(anioDeseado);
        if (respuestaRequestDetalle.status !== 200 || respuestaRequestDetalle.dataResponse === undefined) {
            setstateModalHistoricoDetalle({ ...stateModalHistoricoDetalle, loadingInformacion: false })
            alertService.error(respuestaRequestDetalle.errorMessage ?? "Ha ocurrido un inconveniente al intentar obtener el detalle historico de ese año")
            return
        }
        const data: InformacionDetalleHistorialSolicitudPermisos = respuestaRequestDetalle.dataResponse;
        setstateModalHistoricoDetalle({ tabladetalle: data.tabladetalle, loadingInformacion: false, anio: anioDeseado})
    }


    const cardSolicitudesPermisosyLicencias = useMemo(() => {
        const {
            tiposSolicitudPermisos,
            tiposSolicitudLicencias,
            solicitudesPermisos,
            solicitudesLicencias,
            permisosIngresados,
            licenciasIngresadas,
            permisosCRN,
            anio,
            historial,
            historialbyAnio,
            feriados,
            esSubrogante,
            acuerdoMediosElectronicos,
            horaEntrada,
            horaSalida,
            horaInicioAlmuerzo,
            horaFinAlmuerzo,
            tiempoAlmuerzo,
            esAprobador,
            solicitudesVacaciones,
            licenciasComisiones,
            empHorario,
            historialSolicitudesCH,
            solicitudesIngresadasCH,
            horaEntradaRegimen,
            horaSalidaRegimen,
            subtipoPermisos,
            jornadaLaboralPersona,
            horarioLaboralPersona,
            horarioLaboralRegimen,
            tieneHorarioPermiso,
            tieneInfanteRegistrado,
            vacacionesIngresadas,
            estadoCivil,
            identificacionConyuge,
            tipoEventoMatrimonio,
            modalidadLicenciaMatrimonio,
            tipoIdentificacion,
            Conyuge,
            idRegimenLaboralS,
            listadoHorarios,
            licenciaMaternidad,
            fechaFinContrato,
        } = stateSolicitudPermisos.datosGenerales
        return (
            <CardSolicitudesPermisosLicencias
                tiposSolicitudPermisos={tiposSolicitudPermisos}
                tiposSolicitudLicencias={tiposSolicitudLicencias}
                solicitudesPermisos={solicitudesPermisos}
                solicitudesLicencias={solicitudesLicencias}
                permisosIngresados={permisosIngresados}
                licenciasIngresadas={licenciasIngresadas}
                permisosCRN={permisosCRN}
                onInsertSolicitud={async () => await ObtenerDatosGenerales()}
                anio={anio}
                historial={historial}
                feriados={feriados}
                esSubrogante={esSubrogante}
                acuerdoMediosElectronicos={acuerdoMediosElectronicos}
                horaEntrada={horaEntrada}
                horaSalida={horaSalida}
                tiempoAlmuerzo={tiempoAlmuerzo}
                esAprobador={esAprobador}
                solicitudesVacaciones={solicitudesVacaciones}
                licenciasComisiones={licenciasComisiones}
                diasPendientes={0} horaInicioAlmuerzo={horaInicioAlmuerzo} horaFinAlmuerzo={horaFinAlmuerzo}
                empHorario={empHorario}
                historialSolicitudesCH={historialSolicitudesCH}
                solicitudesIngresadasCH={solicitudesIngresadasCH}
                horaEntradaRegimen={horaEntradaRegimen}
                horaSalidaRegimen={horaSalidaRegimen}
                subtipoPermisos={subtipoPermisos}
                historialbyAnio={historialbyAnio}
                jornadaLaboralPersona={jornadaLaboralPersona}
                horarioLaboralPersona={horarioLaboralPersona}
                horarioLaboralRegimen={horarioLaboralRegimen}
                tieneHorarioPermiso={tieneHorarioPermiso}
                tieneInfanteRegistrado={tieneInfanteRegistrado}
                vacacionesIngresadas={vacacionesIngresadas}
                estadoCivil={estadoCivil}
                identificacionConyuge={identificacionConyuge}
                tipoEventoMatrimonio={tipoEventoMatrimonio}
                modalidadLicenciaMatrimonio={modalidadLicenciaMatrimonio}
                tipoIdentificacion={tipoIdentificacion}
                Conyuge={Conyuge}
                idRegimenLaboralS={idRegimenLaboralS}
                listadoHorarios={listadoHorarios}
                licenciaMaternidad={licenciaMaternidad}
                fechaFinContrato={fechaFinContrato}
            />
        )
    }, [stateSolicitudPermisos.datosGenerales])

    const cardsHistorialSolicitudesVacaciones = useMemo(() => {
        const historial = stateSolicitudPermisos.datosGenerales.historialbyAnio;
        const colores_secuencia = ["#74c9ed", "#195eff", "#961fc2", "#ff7ae9", "#ff7729"];
        if (historial.length > 0) {
            var indiReferencia = 4;
            const cardsHistorial = historial.map((infohist, indihist) => {
                var resultado = escogerIndice(indihist, indiReferencia);
                const indiceColor = resultado.indiceColor;
                indiReferencia = resultado.indiReferencia;
                return (
                    <Col key={"cardHistorialSolicitudes " + indihist} xl={4} lg={6} md={6} sm={12} className="mt-5">
                        <CardHistorialSolicitudesPermisos
                            informacion={infohist}
                            color={colores_secuencia[indiceColor]}
                            verDetalleHistorico={(anioHistorial: number) => VerDetalleHistorico(anioHistorial)}
                        />
                    </Col>
                );
            });
            return cardsHistorial;
        } 
    }, [stateSolicitudPermisos.datosGenerales.historialbyAnio]);


    const contenidoModalDetalleHistorico: any = useMemo(() => {
        if (stateModalHistoricoDetalle.loadingInformacion) {
            return <Cargando />
        }
        else if (stateModalHistoricoDetalle.tabladetalle !== undefined && stateModalHistoricoDetalle.tabladetalle.length === 0) {
            return (
                <>
                    <br />
                    <p className='text-center'>No hay detalle de permisos</p>
                </>
            )
        }
        else if (stateModalHistoricoDetalle.tabladetalle !== undefined && stateModalHistoricoDetalle.tabladetalle.length > 0 && stateModalHistoricoDetalle.loadingInformacion === false) {
            const datosUsuario = authenticationService.currentUserValue.token;
            const tabla =

                <>
                    <Table bordered className="tableHistorialSolicitudesVacaciones" responsive>
                        <thead className="cabecerasDetallehistorialSolic">
                            <tr className="" >
                                <th> F. Solicitud</th>
                                <th> Tipo de solicitud</th>
                                <th> F. Desde</th>
                                <th> F. Hasta</th>
                                <th> Días Solicitados </th>
                                <th> Horas Solicitadas </th>
                                <th> Observación</th>
                                <th> Estado</th>
                                <th> Causa rechazo</th>
                                <th> Documentos</th>

                            </tr>
                        </thead>
                        <tbody>
                            {
                                stateModalHistoricoDetalle.tabladetalle.map((infoHist, indinfoHist) => {
                                    // const textodias = (infoHist.diasOrdinarios !== 1 && infoHist.diasOrdinarios !== -1) ? "días" : (infoHist.diasOrdinarios == 1 || infoHist.diasOrdinario
                                    return (
                                        <tr className="rowHistorialSolicitudVacaciones" key={"rowDetalleHistorico " + indinfoHist + stateModalHistoricoDetalle.anio}>
                                            
                                            <td className="">
                                                <div className="">
                                                    {ObtenerFechaFromIsoFormat(infoHist.fechaSolicitud)}
                                                </div>
                                            </td>
                                            <td className="">
                                                <div className="">
                                                    {infoHist.tipoSolicitud}
                                                </div>
                                            </td>
                                            <td className="">
                                                <div className="">
                                                    {ObtenerFechaFromIsoFormat(infoHist.fechaInicio)}
                                                </div>
                                            </td>
                                            <td className="">
                                                <div className="">
                                                    {ObtenerFechaFromIsoFormat(infoHist.fechaVigHasta ?? infoHist.fechaFin)}
                                                </div>
                                            </td>
                                            <td className="">
                                                <div className="">
                                                    {infoHist.diasSolicitados}
                                                </div>

                                            </td>
                                            <td className="">
                                                <div className="">
                                                {infoHist.horasSolicitadas}
                                                </div>
                                            </td>
                                            <td className="">
                                                <div className="">
                                                {infoHist.observacion}
                                                </div>

                                            </td>
                                            <td className="">
                                                {infoHist.estadoPermiso === "A" && infoHist.referenciaArchivo && (
                                                    <div>Registrado por UATH</div>
                                                )}
                                                {infoHist.estadoPermiso === "A" && !infoHist.referenciaArchivo && (
                                                    <div>Pendiente de confirmación</div>
                                                )}
                                                {infoHist.estadoPermiso== "O" && (
                                                    <div className="">
                                                        Rechazado por Directivo
                                                    </div>
                                                )}
                                                {infoHist.estadoPermiso == "R" && (
                                                    <div className="">
                                                        Anulada Usuario
                                                    </div>
                                                )}
                                                {infoHist.estadoPermiso == "N" && (
                                                    <div className="">
                                                        Rechazado por UATH
                                                    </div>
                                                )}
                                                {infoHist.estadoPermiso == "H" && (
                                                    <div className="">
                                                        Rechazado Doctor ESPOL
                                                    </div>
                                                )}
                                                {infoHist.estadoPermiso == "V" && (
                                                    <div className="">
                                                        Vencida
                                                    </div>
                                                )}
                                                
                                            </td>
                                            <td className="">
                                                <div className="">
                                                    {infoHist.causaRechazo}
                                                </div>
                                            </td>
                                            <td>
                                                {
                                                    infoHist.referenciaProgCita &&
                                                    <i
                                                        onClick={async () => await DownloadDocument(infoHist.referenciaPermiso, datosUsuario, "ProgramacionCita.pdf")}
                                                        data-toggle="tooltip" data-placement="top" title="Descargar Evidencia">
                                                            <img
                                                                src={PdfSVG} // Cambia la ruta al lugar donde esté almacenado tu SVG
                                                                className="acciones"
                                                                alt="Descargar Programación Cita"
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                title="Descargar Programación Cita"
                                                                style={{ width: 24, height: 24 }} // Ajusta el tamaño según necesites
                                                            />
                                                    </i>
                                                }
                                                {
                                                    infoHist.referenciaPermiso &&
                                                    <i
                                                        onClick={async () => await DownloadDocument(infoHist.referenciaPermiso, datosUsuario, "Evidencia.pdf")}
                                                        data-toggle="tooltip" data-placement="top" title="Descargar Evidencia">
                                                            <img
                                                                src={PdfSVG} // Cambia la ruta al lugar donde esté almacenado tu SVG
                                                                className="acciones"
                                                                alt="Descargar Evidencia"
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                title="Descargar Evidencia"
                                                                style={{ width: 24, height: 24 }} // Ajusta el tamaño según necesites
                                                            />
                                                    </i>
                                                }
                                                {
                                                    infoHist.referenciaArchivo &&
                                                    <i
                                                        onClick={async () => await DownloadDocument(infoHist.referenciaArchivo, datosUsuario, "Solicitud.pdf")}
                                                        data-toggle="tooltip" data-placement="top" title="Solicitud de Permiso en pdf ">
                                                            <img
                                                                src={PdfSVG} // Cambia la ruta al lugar donde esté almacenado tu SVG
                                                                className="acciones"
                                                                alt="Descargar Solicitud"
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                title="Descargar Solicitud"
                                                                style={{ width: 24, height: 24 }} // Ajusta el tamaño según necesites
                                                            />
                                                    </i>
                                                }
                                                {
                                                    infoHist.referenciaAp &&
                                                    <i
                                                        onClick={async () => await DownloadDocument(infoHist.referenciaAp, datosUsuario, "AccionPersonal.pdf")}
                                                        data-toggle="tooltip" data-placement="top" title="Acción de Personal en pdf ">
                                                            <img
                                                                src={PdfSVG} // Cambia la ruta al lugar donde esté almacenado tu SVG
                                                                className="acciones"
                                                                alt="Descargar Acción Personal"
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                title="Descargar Acción Personal"
                                                                style={{ width: 24, height: 24 }} // Ajusta el tamaño según necesites
                                                            />
                                                    </i>
                                                }
                                                
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                        
                    </Table>
                </>

            return tabla;
        }
    }, [stateModalHistoricoDetalle])

    const obtenerNombreMes = (numeroMes: number) => {
        const meses = [
            "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
            "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
        ];
        // Restar 1 al número de mes ya que en JavaScript los meses comienzan desde 0
        return meses[numeroMes - 1];
    };

    const contenidoMensajeAlerta = (
        <div>
            {"Su ubicación física es "+stateSolicitudPermisos.datosGenerales.ubicacionFisica+", caso contrario contactarse con la Unidad de Talento Humano, ext. 1169, uath@espol.edu.ec."}
        </div>
    )

    if (stateSolicitudPermisos.loadingDG) {
        return <Cargando mensaje='Cargando Solicitudes'></Cargando>
    }
    else if (stateSolicitudPermisos.mensajeError !== "") {
        return (
            <div className='content'>

            </div>
        )
    }

    return (
        <div className='content'>
            <SolicitudPermisosContextProvider>
                <div className="titulo_seccion_permisos mb-3"> 
                    Solicitudes de permisos y licencias con remuneración
                    <a href="https://talentohumano.espol.edu.ec/Sitio/archivos/GUI-DHO-029_Guia_de_ingreso_de_permisos.pdf" target="_blank">
                        <img
                            src={PdfSVG} // Cambia la ruta al lugar donde esté almacenado tu SVG
                            className="acciones"
                            alt="Guía de ingreso de permisos"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Guía de ingreso de permisos"
                            style={{ width: 24, height: 24 }} // Ajusta el tamaño según necesites
                        />
                    </a>

                    <a href="https://talentohumano.espol.edu.ec/Sitio/archivos/PRO-DHO-033_Gestion_de_licencias_con_remuneracion.pdf" target="_blank">
                        <img
                            src={PdfSVG} // Cambia la ruta al lugar donde esté almacenado tu SVG
                            className="acciones"
                            alt="Guía de gestión de licencias con remuneración"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Guía de gestión de licencias con remuneración"
                            style={{ width: 24, height: 24 }} // Ajusta el tamaño según necesites
                        />
                    </a>
                </div>
                <Row>
                    <Col md={12} xl={12}>
                        {cardSolicitudesPermisosyLicencias}
                    </Col>

                </Row>
                <Row>
                    <Col md={12} xl={12}>

                        <p className="margen-superior  no-margen-inferior titulo-solicitudes"><strong> Historial de solicitudes realizadas</strong></p>
                    </Col>
                        {
                            cardsHistorialSolicitudesVacaciones
                        }

                </Row>
                <ModalConfirmacion
                    show={stateModalHistoricoDetalle.tabladetalle !== undefined || stateModalHistoricoDetalle.loadingInformacion}
                    asyncAccion={false}
                    asyncClose={false}
                    closeAfterAccion={false}
                    hideBotonCerrar={false}
                    mensajeConfirmacion={""}
                    nombreBotonAccion={"Cerrar"}
                    onClose={() => setstateModalHistoricoDetalle({ tabladetalle: undefined, loadingInformacion: false, anio: -1 })}
                    size={"xl"}
                    contentModal={contenidoModalDetalleHistorico}
                    tituloModal={"Detalle permisos/licencias "+stateModalHistoricoDetalle.anio}
                    classNameAllModal={""}
                />

            </SolicitudPermisosContextProvider>


        </div>
    )
}
